import { Radio } from "antd";
import { pMethods } from "@/config/const";

const Component = (props: any) => {
  const {
    globle_physical_method,
    set_globle_physical_method,
    disabled = true,
  } = props;
  const options = [...pMethods];
  const currentLabel = options.find(
    (item) => item.value === (globle_physical_method || "SRK")
  )?.label || globle_physical_method || "SRK";

  if (disabled) {
    return <span style={{ marginLeft: 8,fontSize:16 }}>{currentLabel}</span>;
  }


  return (
    <Radio.Group
      value={globle_physical_method ? globle_physical_method :"SRK"}
      onChange={(e) => {  set_globle_physical_method(e.target.value)}}  >
      {options.map((option) => (
        <Radio key={option.value} value={option.value} disabled={disabled}>
          {option.label}
        </Radio>
      ))}
    </Radio.Group>
  );
};

export default Component;
